import * as React from 'react';
import { Modal, IconButton, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import Header from './header';
import { neutral } from '../theme/colors';
import clsx from 'clsx';

interface Props {
  /** State of the modal */
  isOpen: boolean;
  /** Function to call to close the modal */
  onClose: (open: boolean, option?: any) => void;
  /** Title, displayed in the header */
  title: string;
  /** Optional desciriptive text displayed above the title */
  subtitle?: string;
  /** Optional status text shown on the right side of the header */
  status?: string;
  /** The content of the modal */
  children: React.ReactNode;
  /** Set the width of the entire modal (as an inline style) */
  width: string;
  /** Extra classes */
  className?: string;
  modalClassName?: string;
}

const useStyles = makeStyles({
  container: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '14px 40px 10px 23px',
    backgroundColor: 'white',
    outline: 'none',
    borderRadius: '3px',
    boxShadow: '0 2px 2px 2px rgba(0, 0, 0, 0.07)'
  },
  modal: {
    margin: 'auto'
  },
  exitButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: neutral[600],
    cursor: 'pointer'
  },
  content: {
    flex: 1
  }
});

/**
 * ModalDialog: Base modal with header and close icon button
 */
const ModalDialog = ({
  isOpen,
  onClose,
  subtitle,
  title,
  status,
  children,
  width,
  className,
  modalClassName
}: Props) => {
  const classes = useStyles();
  return (
    <Modal
      className={clsx(classes.modal, modalClassName)}
      style={{ width }}
      open={isOpen}
      onClose={(option?: any) => onClose(!isOpen, option)}
    >
      <div className={clsx(classes.container, className)}>
        <IconButton
          onClick={() => onClose(!isOpen, null)}
          size="small"
          className={classes.exitButton}
        >
          <Close />
        </IconButton>
        <Header title={title} status={status} subtitle={subtitle} />
        <div className={clsx(classes.content, 'modal-content')}>{children}</div>
      </div>
    </Modal>
  );
};

export default ModalDialog;
